import { makeAutoObservable, runInAction } from 'mobx';
import { API_ADMIN_PUSH_NOTIFICATIONS } from 'consts';
import { AxiosMethod, LoadingStatus } from 'enums';
import { NetworkRequestHandler } from 'http/NetworkRequestHandler';
import { Toast } from 'primereact/toast';
import React from 'react';
import { BASE_URL } from 'http/api';

class PushNotificationsStore {
  status: LoadingStatus = LoadingStatus.IDLE;

  constructor() {
    makeAutoObservable(this);
  }

  async sendPushNotification(
    title: string,
    description: string,
    toast: React.MutableRefObject<Toast | null> | null,
  ) {
    this.status = LoadingStatus.PENDING;
    try {
      await NetworkRequestHandler.sendRequest({
        method: AxiosMethod.POST,
        url: `${BASE_URL}${API_ADMIN_PUSH_NOTIFICATIONS}`,
        data: { title, message: description },
      });
      runInAction(() => {
        this.status = LoadingStatus.DONE;
        toast?.current?.show({
          severity: 'success',
          summary: 'Успешно',
          detail: 'Уведомления отправлены',
          life: 3000,
        });
      });
      return true;
    } catch (error: any) {
      runInAction(() => {
        this.status = LoadingStatus.ERROR;
        toast?.current?.show({
          severity: 'error',
          summary: 'Ошибка',
          detail: error.response.data.message,
          life: 3000,
        });
      });
      return false;
    }
  }
}

export default new PushNotificationsStore();
